import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseCellComponent } from '../base-cell.component';

/**
 * Ячейка с типом данных 'float'
 */
@Component({
    selector: 'app-float-cell',
    // eslint-disable-next-line @typescript-eslint/quotes
    template: " {{ getValue() | formater: column.type : '' : column?.transformParam }}",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FloatCellComponent extends BaseCellComponent {
    getValue() {
        return this.getRawValue();
    }
}
